import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

import useDrawerStore from '@/app/shared/infrastructure/state/drawer';
import useRightDrawerStore from '@/app/shared/infrastructure/state/right-drawer';
import userRepository from '@/app/shared/infrastructure/persistence/user-repository';


export default /*#__PURE__*/_defineComponent({
  __name: 'Nav',
  setup(__props) {

const storeRightDrawer = useRightDrawerStore();
const drawerStore = useDrawerStore();
const items = [
    {
        title: 'Faturamento',
        icon: 'mdi:mdi-calculator',
        items: [
            {
                title: 'Gerar fatura',
                link: '/faturas/cadastrar'
            }
        ],
    },
    {
        title: 'Financeiro',
        icon: 'mdi:mdi-cash',
        items: [
            {
                title: 'Reembolso',
                link: '/reembolsos/cadastrar'
            },
            {
                title: 'Contas a pagar',
                link: '/contas-a-pagar/cadastrar'
            },
            {
                title: 'Contas a receber',
                link: '/contas-a-receber/cadastrar'
            },
        ],
    },
    {
        title: 'Projetos',
        icon: 'mdi:mdi-target-variant',
        items: [
            {
                title: 'Nova O.S.',
                link: '/ordens-de-servico/cadastrar'
            },
        ],
    },
    {
        title: 'Meus Cadastros',
        icon: 'mdi:mdi-archive-plus',
        items: [
            {
                title: 'Minha empresa',
                link: '/minha-empresa',
            },
            {
                title: 'Colaboradores',
                link: '/colaboradores/cadastrar',
            },
            {
                title: 'Clientes',
                link: '/clientes',
            },
            {
                title: 'Fornecedores',
                link: '/fornecedores/cadastrar',
            },
            {
                title: 'Centros de custo',
                link: '/centros-de-custo/cadastrar',
            },
            {
                title: 'Projetos',
                link: '/projetos/cadastrar',
            },
        ],
    },
];

const user = userRepository().get();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    height: "72",
    color: "surface",
    elevation: "0"
  }, {
    append: _withCtx(() => [
      _createVNode(_component_v_btn, {
        icon: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(storeRightDrawer).toggle()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_avatar, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                src: _unref(user).image,
                alt: _unref(user).name
              }, null, 8, ["src", "alt"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_btn, {
        icon: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(drawerStore).toggle()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode("mdi:mdi-menu")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        "prepend-icon": "mdi:mdi-plus-box",
        class: "text-capitalize d-none d-sm-flex"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Lançamentos "),
          _createVNode(_component_v_menu, { activator: "parent" }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                return _createVNode(_component_v_btn, {
                  stacked: "",
                  "prepend-icon": item.icon,
                  width: "250",
                  class: "text-capitalize",
                  key: item.title
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title) + " ", 1),
                    _createVNode(_component_v_menu, {
                      location: "end",
                      activator: "parent"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, { nav: "" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (action, i) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: i,
                                value: action.title,
                                title: action.title,
                                density: "compact",
                                to: action.link
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, { class: "mr-3" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi:mdi-circle-small")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["value", "title", "to"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["prepend-icon"])
              }), 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})